require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.observable.js
// module id = ./node_modules/core-js/library/modules/es7.symbol.observable.js
// module chunks = 168707334958949